"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chat = exports.Preview = void 0;
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
const constants_1 = require("../../constants");
const file_record_1 = require("../file/file.record");
class Preview {
}
exports.Preview = Preview;
__decorate([
    (0, property_1.Property)({ default: '' }),
    __metadata("design:type", String)
], Preview.prototype, "title", void 0);
__decorate([
    (0, property_1.Property)({ default: '' }),
    __metadata("design:type", String)
], Preview.prototype, "description", void 0);
__decorate([
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], Preview.prototype, "image", void 0);
class Chat extends mocks_1.Model {
}
exports.Chat = Chat;
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId }),
    __metadata("design:type", String)
], Chat.prototype, "senderId", void 0);
__decorate([
    (0, property_1.Property)({ type: mocks_1.ObjectId, index: true }),
    __metadata("design:type", String)
], Chat.prototype, "visitId", void 0);
__decorate([
    (0, property_1.Property)({ required: false }),
    __metadata("design:type", String)
], Chat.prototype, "text", void 0);
__decorate([
    (0, property_1.Property)({ type: String, enum: constants_1.SendStatusEnum }),
    __metadata("design:type", String)
], Chat.prototype, "sendStatus", void 0);
__decorate([
    (0, property_1.Property)({ type: String, enum: constants_1.ChatTypeEnum }),
    __metadata("design:type", String)
], Chat.prototype, "type", void 0);
__decorate([
    (0, property_1.Property)({ type: Date, required: false }),
    __metadata("design:type", String)
], Chat.prototype, "editedAt", void 0);
__decorate([
    (0, property_1.Property)({ type: Preview, required: false }),
    __metadata("design:type", Preview)
], Chat.prototype, "preview", void 0);
__decorate([
    (0, property_1.Property)({ type: () => mocks_1.ObjectId, required: false }),
    __metadata("design:type", String)
], Chat.prototype, "fileId", void 0);
__decorate([
    (0, property_1.Virtual)({ localIdField: 'fileId', ref: 'fs.files' }),
    __metadata("design:type", file_record_1.FileRecord)
], Chat.prototype, "file", void 0);
